import React, { useState } from 'react';
import { Tooltip } from '../../../../components/Tooltip';

const DiscountPercentBadge = ({ style, tooltiptext }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  const handleMouseEnter = () => {
    setIsTooltipOpen(true);
  };

  const handleMouseLeave = () => {
    setIsTooltipOpen(false);
  };

  return (
    <>
      <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave} onClick={(e) => e.stopPropagation()}>
        <span className="svg-i promo-darkbg percent-tooltip-anchor" style={style} />
      </span>
      {tooltiptext &&
        <Tooltip anchor={`.percent-tooltip-anchor`} isOpen={isTooltipOpen} className="w-240px" place={'top'} style={{ backgroundColor: '#272A37' }}>
          <div className="d-flex align-items-center">
            <div className="font-size-12 ml-12px font-base text-white">{tooltiptext}</div>
          </div>
        </Tooltip>
      }
    </>
  );
};

export default DiscountPercentBadge;
